import F7Event from './events/f7_event';

export default function navigateTo(url, options) {
  document.body.dispatchEvent(new F7Event(app => {
    const path = relativeURL({ url, app });
    app.views.main.router.navigate(path, options);
  }));
}

function relativeURL({ url, app }) {
  const routerParams = app.views.main.router.params;
  if (routerParams.pushStateSeparator)
    return url.split(routerParams.pushStateSeparator)[1];
  else if (routerParams.pushStateRoot)
    return url.replace(routerParams.pushStateRoot, '');
  else
    return null;
}
